// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__wGVOl","empty":"ModalGraph_empty__NFyGI"};